/**
 * The OS share sheet, behind the `navigator.share` check.
 *
 * The button ships `hidden` and is REVEALED here, rather than shipping visible
 * and being hidden by JS. The other order flashes a button that does nothing on
 * every desktop browser, and leaves it visible forever if the bundle fails.
 */
import { qsa, on } from './dom.js';

export function setupShare() {
  const buttons = qsa('[data-share]');
  if (!buttons.length) return;

  // Feature detection, not a user-agent test: some desktop browsers do have it.
  if (typeof navigator.share !== 'function') return;

  for (const button of buttons) {
    button.hidden = false;

    on(button, 'click', async () => {
      try {
        await navigator.share({
          title: button.dataset.shareTitle || document.title,
          text: button.dataset.shareText || '',
          url: button.dataset.shareUrl || location.href,
        });
      } catch (error) {
        // The visitor dismissing the sheet rejects the promise with
        // AbortError. That is not a failure and must not be logged as one.
        if (error?.name !== 'AbortError') console.error('[share]', error);
      }
    });
  }
}
